import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { fixtureContext } from "../context/FixtureContext";

import Textarea from "@mui/joy/Textarea";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import useLoginfo from "../../utils/useLoginfo";

const EditFixture = () => {
  const { addUpdateFixtureAction, getSingleFixtureAction, fixtSingleRow } =
    useContext(fixtureContext);

  const history = useHistory();
  //OKTA
  const { tokenVal } = useLoginfo()

  const { updateID } = useParams();

  useEffect(() => {

    getSingleFixtureAction({
      f: updateID.split("-")[0],
      i: updateID.split("-")[1],
      j: updateID.split("-")[2],
    }, tokenVal);

  }, [tokenVal]);

  const [formData, setFormData] = useState({
    PLANO_NBR: "",
    SERIAL: "",
    LIMITLESS_POG: "",
    ITEM_NBR: "",
    QTY: "",
    CTB_FREE_ITEM: "",
    NEEDED_PROMPT: "",
    ORDER_INFO: "",
    SEND_TO_NETWAREHOUSE: "",
    OVERRIDE: "",
    FIXTURE_KEY: "",
    USER: "0",
    SHOW_FIXTURE: "",
    FIXTURE_ITEM: "",
    LEVEL: "FIXTURE",
  });

  useEffect(() => {
    // console.log(fixtSingleRow);

    setFormData({
      PLANO_NBR: fixtSingleRow?.PLANO_NBR,
      SERIAL: fixtSingleRow?.SERIAL,
      LIMITLESS_POG: fixtSingleRow?.LIMITLESS_POG,
      ITEM_NBR: fixtSingleRow?.ITEM_NBR,
      QTY: fixtSingleRow?.QTY,
      CTB_FREE_ITEM: fixtSingleRow?.CTB_FREE_ITEM,
      NEEDED_PROMPT: fixtSingleRow?.NEEDED_PROMPT,
      ORDER_INFO: fixtSingleRow?.ORDER_INFO,
      SEND_TO_NETWAREHOUSE: fixtSingleRow?.SEND_TO_NETWAREHOUSE,
      OVERRIDE: fixtSingleRow?.OVERRIDE,
      FIXTURE_KEY: fixtSingleRow?.FIXTURE_KEY,
      USER: "0",
      SHOW_FIXTURE: fixtSingleRow?.SHOW_FIXTURE,
      FIXTURE_ITEM: fixtSingleRow?.FIXTURE_ITEM,
      LEVEL: "FIXTURE",
    });
  }, [fixtSingleRow]);

  //handle form change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [flag, setflag] = useState(false);

  //handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    //add Assortment_ID
    if (flag) {
      // console.log({ ...formData });
      if (formData.ORDER_INFO.split(";").length > 3) alert("Order Info can have maximum 3 email id")
      else {
        addUpdateFixtureAction([{ ...formData }], tokenVal, history)
        // history.push("/fixtures");
      }
    }
  };

  //handle form cancel
  const handleCancel = (e) => {
    window.location.href = "/fixtures";
  };

  return (
    <div>
      <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        style={{ marginLeft: "15px" }}
      >
        <Link underline="hover" color="inherit" href="/fixtures">
          View Fixtures
        </Link>
        <Link
          underline="hover"
          color="text.primary"
          href={`/edit-fixture/${updateID.split("-")[0]}-${updateID.split("-")[1]
            }-${updateID.split("-")[2]}`}
          aria-current="page"
        >
          Edit Fixture Form
        </Link>
      </Breadcrumbs>
      <h2 style={{ textAlign: "center" }}>Edit Fixture Form</h2>

      <form
        style={{ marginBottom: "40px", marginTop: "-40px" }}
        className="flex-container"
        onSubmit={handleSubmit}
      >
        <div style={{ marginLeft: "15px" }}>
          <div className="flex-container">
            <label className="">Send to Order Billing</label>

            <TextField
              size="small"
              required={flag}
              name="SEND_TO_NETWAREHOUSE"
              value={formData.SEND_TO_NETWAREHOUSE}
              onChange={handleChange}
              className="depart"
              id="outlined-select-active"
              select
            >
              <MenuItem key="Y" value="Y">
                Y
              </MenuItem>
              <MenuItem key="N" value="N">
                N
              </MenuItem>
            </TextField>
          </div>

          <div className="flex-container">
            <label className="">Needed Prompt</label>

            <TextField
              size="small"
              required={flag}
              name="NEEDED_PROMPT"
              value={formData.NEEDED_PROMPT}
              onChange={handleChange}
              className="depart"
              id="outlined-select-active"
              select
            >
              <MenuItem key="Y" value="Y">
                Y
              </MenuItem>
              <MenuItem key="N" value="N">
                N
              </MenuItem>
            </TextField>
          </div>

          <div className="flex-container">
            <label className="">Do Not Override</label>

            <TextField
              size="small"
              required={flag}
              name="OVERRIDE"
              value={formData.OVERRIDE}
              onChange={handleChange}
              className="depart"
              id="outlined-select-active"
              select
            >
              <MenuItem key="N" value="N">
                Y
              </MenuItem>
              <MenuItem key="Y" value="Y">
                N
              </MenuItem>
            </TextField>
          </div>

          <div className="flex-container">
            <label className="">CTB Free Item</label>

            <TextField
              size="small"
              required={flag}
              name="CTB_FREE_ITEM"
              value={formData.CTB_FREE_ITEM}
              onChange={handleChange}
              className="depart"
              id="outlined-select-active"
              select
            >
              <MenuItem key="Y" value="Y">
                Y
              </MenuItem>
              <MenuItem key="N" value="N">
                N
              </MenuItem>
            </TextField>
          </div>
        </div>

        <div style={{ marginLeft: "15px", marginTop: "85px" }}>
          <div className="flex-container">
            <label className="">Order Info</label>

            <Textarea
              variant="outlined"
              minRows={3}
              required={true}
              className="depart"
              name="ORDER_INFO"
              value={formData.ORDER_INFO}
              onChange={handleChange}
              type="text"
            />
          </div>

          <div className="flex-container">
            <label className="">Quantity</label>

            <TextField
              style={{ background: "rgb(247, 247, 248)" }}
              disabled={true}
              size="small"
              required={flag}
              name="QTY"
              value={formData.QTY}
              onChange={handleChange}
              type="text"
              id="outlined-mark"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">SKU Number</label>

            <TextField
              style={{ background: "rgb(247, 247, 248)" }}
              disabled={true}
              size="small"
              required={flag}
              name="ITEM_NBR"
              value={formData.ITEM_NBR}
              onChange={handleChange}
              type="text"
              id="outlined-dating"
              className="depart"
            />
          </div>

          <div style={{ marginTop: "105px", display: "flex" }}>
            <div className="save-btn">
              <Button
                type="submit"
                variant="contained"
                color="success"
                onClick={(e) => setflag(true)}
                size="large"
              >
                <span className="cat-radio">Save</span>
              </Button>
            </div>
            <div>
              <Button
                className=""
                variant="contained"
                color="error"
                onClick={handleCancel}
                size="large"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
        <div></div>
      </form>
    </div>
  );
};

export default EditFixture;
